// This file is imported in all theme.liquid pages (most of Shopify pages uses theme.liquid).
import {renderStructuredElements} from "@/utils/render-helpers.jsx";
import Cart from "@/components/Cart";

document.addEventListener("DOMContentLoaded", () => {
  renderStructuredElements("cart", Cart);
});
